export default __webpack_public_path__ + "static/media/15.491ac63e.png";